import React from "react"
import axios from "axios"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { Badge, Button, Col, Input, Row, Table } from "reactstrap"

import { Loading, PageContainer } from "../../components"
import { fail } from "../../actions"

const statusColor = (status) =>
  status < 300 ? "success" : status < 500 ? "warning" : "danger"

// Super admin view into the audit trail (auditlogs collection)
class AuditLog extends React.Component {
  state = {
    fetching: false,
    auditlogs: [],
    email: "",
    path: "",
    customerId: "",
    from: "",
    to: "",
    limit: 100,
    expanded: null,
  }

  componentDidMount = () => this.fetch()

  handleChange = ({ target }) => this.setState({ [target.name]: target.value })

  fetch = async () => {
    this.setState({ fetching: true, expanded: null })
    try {
      const params = {}
      for (const key of ["email", "path", "customerId", "from", "to", "limit"]) {
        if (this.state[key]) params[key] = this.state[key]
      }
      const { data } = await axios.get("/auditlogs", { params })
      this.setState({ fetching: false, auditlogs: data.auditlogs || [] })
    } catch (error) {
      this.props.fail(null, error).then(() => this.setState({ fetching: false }))
    }
  }

  render() {
    const { t } = this.props
    return (
      <PageContainer title={t("_auditLog")}>
        <Row className="mb-2">
          <Col md="2">
            <Input
              name="email"
              placeholder={t("_email")}
              value={this.state.email}
              onChange={this.handleChange}
            />
          </Col>
          <Col md="2">
            <Input
              name="path"
              placeholder="path"
              value={this.state.path}
              onChange={this.handleChange}
            />
          </Col>
          <Col md="2">
            <Input
              name="customerId"
              placeholder="customerId"
              value={this.state.customerId}
              onChange={this.handleChange}
            />
          </Col>
          <Col md="2">
            <Input
              type="date"
              name="from"
              value={this.state.from}
              onChange={this.handleChange}
            />
          </Col>
          <Col md="2">
            <Input
              type="date"
              name="to"
              value={this.state.to}
              onChange={this.handleChange}
            />
          </Col>
          <Col md="2">
            <Button color="primary" block onClick={this.fetch}>
              {t("_search")}
            </Button>
          </Col>
        </Row>
        {this.state.fetching ? (
          <Loading />
        ) : (
          <Table size="sm" hover>
            <thead>
              <tr>
                <th>{t("_time")}</th>
                <th>{t("_email")}</th>
                <th>{t("_action")}</th>
                <th>Status</th>
                <th>{t("_customer")}</th>
              </tr>
            </thead>
            <tbody>
              {this.state.auditlogs.map((log, i) => (
                <React.Fragment key={log.id || i}>
                  <tr
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.setState({
                        expanded: this.state.expanded === i ? null : i,
                      })
                    }
                  >
                    <td>{new Date(log.time).toLocaleString("fi-FI")}</td>
                    <td>{log.email || "-"}</td>
                    <td>
                      <code>{`${log.method} ${log.path}`}</code>
                    </td>
                    <td>
                      <Badge color={statusColor(log.status)}>{log.status}</Badge>
                    </td>
                    <td>
                      <small>{log.customerId || ""}</small>
                    </td>
                  </tr>
                  {this.state.expanded === i && (
                    <tr>
                      <td colSpan={5}>
                        <pre
                          style={{
                            whiteSpace: "pre-wrap",
                            fontSize: 12,
                            background: "#f7f7f7",
                            padding: 8,
                          }}
                        >
                          {JSON.stringify(log.body, null, 2)}
                          {"\n"}
                          {`ip: ${log.ip || "-"} | ${log.durationMs} ms | admin: ${
                            log.isAdmin ? "yes" : "no"
                          } | reseller: ${log.isReseller ? "yes" : "no"}`}
                        </pre>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        )}
      </PageContainer>
    )
  }
}

export default connect(null, { fail })(withTranslation()(AuditLog))
